/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Ranked_HintInputs */



/**
* | output |
* | --- |
* | "Counts for the VEKN ranking: at least 8 players and a final (rule 3.1)." |
*
* @param {Tournament_Ranked_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_ranked_hint = /** @type {((inputs?: Tournament_Ranked_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Ranked_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte pour le classement VEKN : au moins 8 joueurs et une finale (règle 3.1).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuenta para el ranking de la VEKN: al menos 8 jugadores y una final (regla 3.1).")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conta para o ranking da VEKN: pelo menos 8 jogadores e uma final (regra 3.1).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conta per il ranking VEKN: almeno 8 giocatori e una finale (regola 3.1).")
	return /** @type {LocalizedString} */ ("Counts for the VEKN ranking: at least 8 players and a final (rule 3.1).")
});